// @ts-nocheck
/* 滿版輪播 Banner（allando-banner）行為 */

(function () {
  'use strict';

  if (customElements.get('allando-banner')) return;

  class AllandoBanner extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.allando-banner__track');
      this.slides = Array.from(this.querySelectorAll('.allando-banner__slide'));
      this.dots = Array.from(this.querySelectorAll('.allando-banner__dot'));
      this.prevBtn = this.querySelector('.allando-banner__arrow--prev');
      this.nextBtn = this.querySelector('.allando-banner__arrow--next');

      this.autoplay = this.dataset.autoplay === 'true';
      this.intervalMs = (parseFloat(this.dataset.interval) || 5) * 1000;
      this.loop = this.dataset.loop === 'true';

      this.index = 0;
      this.timer = null;
      this.rafId = null;

      // 單張投影片：無需任何輪播控制
      if (!this.track || this.slides.length <= 1) return;

      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.onScroll = this.onScroll.bind(this);
      this.start = this.start.bind(this);
      this.stop = this.stop.bind(this);
      this.onVisibility = this.onVisibility.bind(this);
      this.onResize = this.onResize.bind(this);

      this.bindEvents();
      this.updateUI();

      if (this.autoplay && !this.reduceMotion) this.start();
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('visibilitychange', this.onVisibility);
      window.removeEventListener('resize', this.onResize);
    }

    bindEvents() {
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          this.prev();
          this.restart();
        });
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          this.next();
          this.restart();
        });
      }

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          this.goTo(i);
          this.restart();
        });
      });

      // hover / 觸控按住暫停
      this.addEventListener('mouseenter', this.stop);
      this.addEventListener('mouseleave', this.start);
      this.addEventListener('touchstart', this.stop, { passive: true });
      this.addEventListener('touchend', this.start, { passive: true });

      document.addEventListener('visibilitychange', this.onVisibility);
      window.addEventListener('resize', this.onResize);
    }

    slideWidth() {
      return this.track.clientWidth;
    }

    goTo(i, smooth) {
      const max = this.slides.length - 1;
      let target = i;
      if (target < 0) target = this.loop ? max : 0;
      if (target > max) target = this.loop ? 0 : max;
      this.index = target;
      this.track.scrollTo({
        left: this.slideWidth() * target,
        behavior: smooth === false || this.reduceMotion ? 'auto' : 'smooth'
      });
      this.updateUI();
    }

    next() {
      const max = this.slides.length - 1;
      if (this.index >= max && !this.loop) {
        this.stop();
        return;
      }
      this.goTo(this.index + 1);
    }

    prev() {
      this.goTo(this.index - 1);
    }

    onScroll() {
      if (this.rafId) cancelAnimationFrame(this.rafId);
      this.rafId = requestAnimationFrame(() => {
        const i = Math.round(this.track.scrollLeft / this.slideWidth());
        if (i !== this.index) {
          this.index = i;
          this.updateUI();
        }
      });
    }

    updateUI() {
      this.dots.forEach((dot, i) => {
        dot.setAttribute('aria-current', i === this.index ? 'true' : 'false');
      });
      if (!this.loop) {
        const max = this.slides.length - 1;
        if (this.prevBtn) this.prevBtn.disabled = this.index <= 0;
        if (this.nextBtn) this.nextBtn.disabled = this.index >= max;
      }
    }

    start() {
      if (!this.autoplay || this.reduceMotion) return;
      this.stop();
      this.timer = setInterval(() => this.next(), this.intervalMs);
    }

    stop() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    restart() {
      if (this.autoplay && !this.reduceMotion) this.start();
    }

    onVisibility() {
      if (document.hidden) this.stop();
      else this.start();
    }

    onResize() {
      // 重新對齊目前投影片，避免 resize 後錯位
      this.goTo(this.index, false);
    }
  }

  customElements.define('allando-banner', AllandoBanner);
})();
